import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { verifyEmail } from '../api/client';
import { HeartLogo } from '../components/hbs/HeartLogo';

type State = 'verifying' | 'success' | 'error';

export default function VerifyEmailPage(): JSX.Element {
  const [params] = useSearchParams();
  const [state, setState] = useState<State>('verifying');

  useEffect(() => {
    const token = params.get('token');
    if (!token) {
      setState('error');
      return;
    }
    let cancelled = false;
    verifyEmail({ token }).then((res) => {
      if (!cancelled) setState(res.ok ? 'success' : 'error');
    });
    return () => {
      cancelled = true;
    };
  }, [params]);

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-hbs-bg p-6">
      <div className="w-full max-w-sm bg-hbs-surface rounded-hbs-xl border border-hbs-border p-8 shadow-hbs-lg flex flex-col items-center gap-4 text-center">
        <HeartLogo size={56} />
        {state === 'verifying' && (
          <p className="text-[14px] text-hbs-text-mute" role="status">Verifying your email…</p>
        )}
        {state === 'success' && (
          <>
            <h1 className="font-display text-[22px] tracking-hbs-tight text-hbs-text">
              Your email is verified <span aria-hidden="true">✓</span>
            </h1>
            <p className="text-[14px] text-hbs-text-mute">
              Thanks for confirming your address. You can close this tab.
            </p>
          </>
        )}
        {state === 'error' && (
          <>
            <h1 className="font-display text-[22px] tracking-hbs-tight text-hbs-text">
              Verification failed
            </h1>
            <p className="text-[14px] text-hbs-text-mute" role="alert">
              This verification link is invalid or has expired.
            </p>
          </>
        )}
      </div>
    </div>
  );
}
